import { Fragment, ComponentType, ReactNode } from 'react';
import QuickDepositModal from '../quick-deposit-modal';
import { JSONObject } from '~/components/payment-beta/types';
import { NormalisedExecuteDepositDAO } from '~/components/payment-beta/types/deposit';
import { MAIN_CONTENT, QD_EXECUTE, QD_REDIRECT_URL } from '../../utils/constants';
import { SendHandler } from '~/components/payment-beta/components/execute/constants';

type ActionT = {
	onClose?: (cb: void) => void;
	onSuccess?: (item: JSONObject) => void;
};

export type CustomPropsT = {
	actions: ActionT;
	wrapper: ComponentType<{ children: ReactNode }>;
} | null;

export type ExecuteHandlerPropsT = {
	result: JSONObject;
	updateViews: (cb: void) => void;
	hideView: (...views: string[]) => void;
	addView: (view: string) => void;
	setResultParams: (obj: JSONObject) => void;
	fullLocation: string;
};

export const deduceCustomProps = (result: NormalisedExecuteDepositDAO, props: ExecuteHandlerPropsT) => {
	const { updateViews, addView, hideView, setResultParams, fullLocation } = props;
	const { accHistRef, actualSendHandler, paymentFetchResultFlow } = result;

	let customProps: CustomPropsT = { actions: {}, wrapper: Fragment }; // return customProps = null to skip execute step rendering in the parent

	switch (actualSendHandler) {
		case SendHandler.ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL:
		case SendHandler.RESULT_AFTER_SINGLE_CALL: {
			setResultParams({ accHistRef, paymentFetchResultFlow }); // TODO: verify fetch_type removal
			customProps = null;
			break;
		}

		case SendHandler.EXTERNAL_PANEL: {
			customProps.actions.onClose = () => {
				updateViews(hideView(QD_EXECUTE));
				updateViews(addView(MAIN_CONTENT));
			};
			customProps.actions.onSuccess = setResultParams;
			customProps.wrapper = QuickDepositModal;
			break;
		}

		case SendHandler.EXTERNAL_WINDOW:
			window.localStorage.setItem(QD_REDIRECT_URL, JSON.stringify(fullLocation));
			break;

		case SendHandler.NATIVE_APP: {
			customProps.actions.onClose = () => {
				updateViews(hideView(QD_EXECUTE));
				updateViews(addView(MAIN_CONTENT));
			};
			customProps.actions.onSuccess = () => {
				updateViews(hideView(QD_EXECUTE));
				setResultParams({ accHistRef });
			};
			break;
		}

		default:
			console.log(`qd-execute-handler: actualSendHandler ${actualSendHandler}`);
	}

	return customProps;
};
